import { gql } from "@apollo/client";

import { remoteAssetFragment } from "../fragments/remoteAssetFragment";

export const getRemoteAssets = gql`
    query getRemoteAssets($organizationId: ID!, $query: String, $cursor: String, $limit: Int!) {
        remoteAssets(input: { organizationId: $organizationId, query: $query, cursor: $cursor, limit: $limit }) {
            nodes {
                ...RemoteAssetFields
            }
            cursor
        }
    }
    ${remoteAssetFragment}
`;
